import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';
import { type RecoveryErrorKind } from '@socios-blk/browser';

export type RecoveryErrorDrawerProps = {
	error: RecoveryErrorKind;
	setError: (to: undefined) => void;
};

export const RecoveryErrorDrawer = ({ error, setError }: RecoveryErrorDrawerProps) => {
	const { $t } = useIntl();

	const intlText = {
		buttonText: $t('ncOnboarding.registration.errorButton'),
		description: $t(
			`ncOnboarding.recoveryKit.recoverWallet.errorDescriptions.${error}` as Parameters<typeof $t>[0]
		),
		title: $t('ncOnboarding.registration.errorTitle')
	};

	return (
		<GenericDrawer
			buttonText={intlText.buttonText}
			description={intlText.description}
			image={GoatAwkward}
			testID="recoveryError"
			title={intlText.title}
			onButtonPress={() => setError(undefined)}
		/>
	);
};
